module.exports = __webpack_public_path__ + "img/floor1_3.c7565ae3.jpg";